export default __webpack_public_path__ + "static/media/16.ba6a2b48.png";